import type { RouteRecordRaw } from "vue-router";
import { ROUTE_NAMES, ROUTE_PATHS } from "../constants";

export const clientEmployeeRoutes: RouteRecordRaw[] = [
  {
    path: ROUTE_PATHS.CLIENT_EMPLOYEES,
    name: ROUTE_NAMES.CLIENT_EMPLOYEES,
    component: () => import("@/pages/ClientEmployeesPage.vue"),
  },
  {
    path: `${ROUTE_PATHS.CLIENT_EMPLOYEES}/:id`,
    name: ROUTE_NAMES.CLIENT_EMPLOYEE_DETAIL,
    component: () => import("@/pages/ClientEmployeeDetailPage.vue"),
  },
];
